import React from 'react';
import ReactSelect, { ActionMeta, StylesConfig, components, SingleValue } from 'react-select';

interface SelectOption {
  value: string;
  label: string;
}

interface SingleSelectProps {
  options: SelectOption[];
  value: SelectOption | null;
  onChange: (value: SelectOption | null, actionMeta: ActionMeta<SelectOption>) => void;
  isSearchable?: boolean;
  type?: 'year' | 'entity' | 'employee' | 'title';
}

export const SingleSelect: React.FC<SingleSelectProps> = ({
  options,
  value,
  onChange,
  isSearchable = true,
  type = 'entity',
}) => {
  const onChangeHandler = (newValue: SingleValue<SelectOption>, actionMeta: ActionMeta<SelectOption>) => {
    onChange(newValue ?? null, actionMeta);
  };

  const ValueContainer = (props: any) => {
    const { children, ...rest } = props;
    const selectedArray = props.getValue() as SelectOption[];
    const selected = selectedArray.length > 0 ? selectedArray[0] : null;
    const displayLabel = selected?.value ?? 'none';

    return (
      <components.ValueContainer {...rest}>
        <div
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            lineHeight: 1,
            fontSize: '14px',
            padding: '2px 4px',
          }}
        >
          {displayLabel}
        </div>
      </components.ValueContainer>
    );
  };

  const MenuList = (props: any) => {
    return <components.MenuList {...props}>{props.children}</components.MenuList>;
  };

  const customStyles: StylesConfig<SelectOption, false> = {
    valueContainer: (base) => ({
      ...base,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      minHeight: '30px',
      padding: '2px 4px',
    }),
    singleValue: (base) => ({
      ...base,
      lineHeight: 1,
    }),
    control: (base) => ({
      ...base,
      minHeight: '30px',
    }),
  };

  return (
    <ReactSelect<SelectOption, false>
      options={options}
      value={value}
      onChange={onChangeHandler}
      closeMenuOnSelect={true}
      isSearchable={isSearchable}
      styles={customStyles}
      components={{ ValueContainer, MenuList }}
    />
  );
};
